module.exports = __webpack_public_path__ + "img/22.82587503.png";